/**
 * Renders a Google Material Symbol by name (the icon names stored on DIN 276 metadata,
 * e.g. "door_front", "water_drop"). The font is loaded in public/index.html and the base
 * class is defined in App.sass.
 */
interface Properties {
  name?: string | null;
  color?: string;
  size?: number;
  title?: string;
  className?: string;
}

export default function MaterialSymbol({
  name,
  color,
  size = 20,
  title,
  className,
}: Properties) {
  if (!name) {
    return null;
  }
  return (
    <span
      className={`material-symbols-outlined${className ? ` ${className}` : ""}`}
      style={{ fontSize: size, color, lineHeight: 1 }}
      title={title}
      aria-hidden={title ? undefined : true}
    >
      {name}
    </span>
  );
}
